// // Simulator.jsx
// import React, { useState, useEffect } from 'react';
// import {
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     Button,
//     TextField,
//     Typography,
//     Box,
//     LinearProgress,
//     Snackbar,
//     Alert,
//     Chip,
//     Modal,
//     Select,
//     MenuItem,
//     FormControl,
//     IconButton,
//     Tooltip,
//     InputLabel,
//     Grid,
//     Divider,
//     CircularProgress,
//     Accordion,
//     AccordionSummary,
//     AccordionDetails
// } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import dayjs from 'dayjs';
// import { useParams } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import EditIcon from '@mui/icons-material/Edit';
// import SaveIcon from '@mui/icons-material/Save';
// import CancelIcon from '@mui/icons-material/Cancel';
// import LockOpenIcon from '@mui/icons-material/LockOpen';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import CancelIconRed from '@mui/icons-material/Cancel';
// import AssessmentIcon from '@mui/icons-material/Assessment';
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
// import AddIcon from '@mui/icons-material/Add';
// import DeleteIcon from '@mui/icons-material/Delete';
// import {
//     markAllStudentSimulator,
//     getAllStudentSimulator,
//     getSimulatorStatistics,
//     downloadSimulatorExcel,
//     deleteStudentSimulatorRecords,
//     deleteBatchSimulatorRecords,
//     deleteSimulatorRecord
// } from '../../../helpers/simulator_helper';

// const SCENARIO_OPTIONS = [
//     { value: 'City_Driving', label: 'City Driving' },
//     { value: 'Highway_Driving', label: 'Highway Driving' },
//     { value: 'Practice_Area', label: 'Practice Area' },
//     { value: 'Country_Driving', label: 'Country Driving' },
//     { value: 'Hill_Driving', label: 'Hill Driving' },
// ];

// // Result options
// const RESULT_OPTIONS = [
//     { value: 'NOT_ATTEMPTED', label: 'Not Attempted', color: 'default' },
//     { value: 'PASS', label: 'Pass', color: 'success' },
//     { value: 'FAIL', label: 'Fail', color: 'error' },
// ];

// const ALLOW_EDIT_USERS = ['Admin', 'Super Admin', 'Project Manager', 'Tata Project Manager', 'Trainer', 'Tata Trainer'];

// const Simulator = ({ students, batchDetails }) => {
//     // Store multiple scenarios per student
//     const [studentRecords, setStudentRecords] = useState({});
//     const [loading, setLoading] = useState(false);
//     const [submitting, setSubmitting] = useState(false);
//     const params = useParams();
//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: '',
//         severity: 'success'
//     });
    
//     const [isEditing, setIsEditing] = useState(false);
//     const [tempRecords, setTempRecords] = useState({});
//     const [userType, setUserType] = useState('');
//     const [canEditData, setCanEditData] = useState(false);
//     const [validationErrors, setValidationErrors] = useState({});
//     const [filteredStudents, setFilteredStudents] = useState(null);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [loader, setLoader] = useState(false);
//     const [statistics, setStatistics] = useState(null);
//     const [expandedStudents, setExpandedStudents] = useState({});
//     const [lastUpdated, setLastUpdated] = useState(null);

//     useEffect(() => {
//         const authUser = JSON.parse(localStorage.getItem('authUser'));
//         const currentUserType = authUser?.userType || '';
//         setUserType(currentUserType);
//         setCanEditData(ALLOW_EDIT_USERS.includes(currentUserType));
//     }, []);

//     // Fetch all simulator data for the batch (no date filter - one-time activity)
//     const fetchAllSimulatorData = async () => {
//         if (!students || students.length === 0) return;

//         try {
//             setLoading(true);
//             setIsEditing(false);
//             setValidationErrors({});
//             setStatistics(null);

//             // Fetch all simulator records for this batch (no date parameter)
//             const response = await getAllStudentSimulator(params.id);
            
//             const fetchedRecords = {};
            
//             // Initialize each student with default records
//             students.forEach(student => {
//                 fetchedRecords[student.id] = [
//                     {
//                         id: null,
//                         scenario: 'Practice_Area',
//                         result: 'NOT_ATTEMPTED',
//                         duration: 15,
//                         isNew: true,
//                         createdAt: null,
//                         updatedAt: null,
//                         recordDate: null
//                     }
//                 ];
//             });
            
//             if (response?.success && response?.result && Array.isArray(response.result)) {
//                 // Group records by student ID
//                 const recordsByStudent = {};
//                 response.result.forEach(record => {
//                     if (record.studentId) {
//                         if (!recordsByStudent[record.studentId]) {
//                             recordsByStudent[record.studentId] = [];
//                         }
//                         recordsByStudent[record.studentId].push({
//                             id: record.id,
//                             scenario: record.scenario || 'Practice_Area',
//                             result: record.result || 'NOT_ATTEMPTED',
//                             duration: record.duration || 15,
//                             isNew: false,
//                             createdAt: record.entryAt || record.createdAt,
//                             updatedAt: record.updatedAt,
//                             recordDate: record.date
//                         });
//                     }
//                 });
                
//                 // Update fetched records with actual data
//                 Object.keys(recordsByStudent).forEach(studentId => {
//                     if (fetchedRecords[studentId]) {
//                         fetchedRecords[studentId] = recordsByStudent[studentId];
//                     }
//                 });

//                 // Get last updated timestamp
//                 const lastUpdatedRecord = response.result.reduce((latest, record) => {
//                     if (!latest || (record.updatedAt && record.updatedAt > latest.updatedAt)) {
//                         return record;
//                     }
//                     return latest;
//                 }, null);
                
//                 if (lastUpdatedRecord) {
//                     setLastUpdated(lastUpdatedRecord.updatedAt);
//                 }
//             }

//             setStudentRecords(fetchedRecords);
//             setTempRecords(JSON.parse(JSON.stringify(fetchedRecords)));

//             // Fetch statistics (no date filter)
//             try {
//                 const statsResponse = await getSimulatorStatistics(params.id);
//                 if (statsResponse?.success && statsResponse?.statistics) {
//                     setStatistics(statsResponse.statistics);
//                 }
//             } catch (statsError) {
//                 console.log('Statistics not available');
//             }

//         } catch (error) {
//             console.error('Error in fetchAllSimulatorData:', error);
//             const defaultRecords = {};
//             students?.forEach(student => {
//                 defaultRecords[student.id] = [
//                     {
//                         id: null,
//                         scenario: 'Practice_Area',
//                         result: 'NOT_ATTEMPTED',
//                         duration: 15,
//                         isNew: true,
//                         createdAt: null,
//                         updatedAt: null,
//                         recordDate: null
//                     }
//                 ];
//             });
//             setStudentRecords(defaultRecords);
//             setTempRecords(JSON.parse(JSON.stringify(defaultRecords)));
//             toast.error('Error fetching simulator data');
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (params.id && students && students.length > 0) {
//             fetchAllSimulatorData();
//         }
//     }, [params.id, students]);

//     const handleAddScenario = (studentId) => {
//         const currentRecords = isEditing ? tempRecords : studentRecords;
//         const studentRecordList = currentRecords[studentId] || [];
        
//         // Check if there's already a "NOT_ATTEMPTED" record
//         const hasNotAttempted = studentRecordList.some(r => r.result === 'NOT_ATTEMPTED');
        
//         const newRecord = {
//             id: null,
//             scenario: 'Practice_Area',
//             result: hasNotAttempted ? 'PASS' : 'NOT_ATTEMPTED',
//             duration: 15,
//             isNew: true,
//             createdAt: null,
//             updatedAt: null,
//             recordDate: dayjs().format('YYYY-MM-DD')
//         };
        
//         const updatedRecords = {
//             ...currentRecords,
//             [studentId]: [...studentRecordList, newRecord]
//         };
        
//         if (isEditing) {
//             setTempRecords(updatedRecords);
//         } else {
//             setStudentRecords(updatedRecords);
//         }
//     };

//     const handleRemoveScenario = (studentId, index) => {
//         const currentRecords = isEditing ? tempRecords : studentRecords;
//         const studentRecordList = currentRecords[studentId] || [];
        
//         if (studentRecordList.length <= 1) {
//             toast.warning('Each student must have at least one scenario');
//             return;
//         }
        
//         const updatedList = studentRecordList.filter((_, i) => i !== index);
//         const updatedRecords = {
//             ...currentRecords,
//             [studentId]: updatedList
//         };
        
//         if (isEditing) {
//             setTempRecords(updatedRecords);
//         } else {
//             setStudentRecords(updatedRecords);
//         }
//     };

//     const handleRecordChange = (studentId, index, field, value) => {
//         const currentRecords = isEditing ? tempRecords : studentRecords;
//         const studentRecordList = [...(currentRecords[studentId] || [])];
        
//         if (field === 'result' && value !== 'NOT_ATTEMPTED') {
//             // If setting PASS or FAIL, check if there's already a NOT_ATTEMPTED record
//             // and it's not the current one
//             const hasNotAttempted = studentRecordList.some((r, i) => 
//                 i !== index && r.result === 'NOT_ATTEMPTED'
//             );
//             if (hasNotAttempted) {
//                 // Remove the NOT_ATTEMPTED record
//                 const notAttemptedIndex = studentRecordList.findIndex((r, i) => 
//                     i !== index && r.result === 'NOT_ATTEMPTED'
//                 );
//                 if (notAttemptedIndex !== -1) {
//                     studentRecordList.splice(notAttemptedIndex, 1);
//                 }
//             }
//         }
        
//         studentRecordList[index] = {
//             ...studentRecordList[index],
//             [field]: value,
//             // If result is changed from NOT_ATTEMPTED, mark as not new
//             isNew: studentRecordList[index].isNew && value === 'NOT_ATTEMPTED'
//         };
        
//         const updatedRecords = {
//             ...currentRecords,
//             [studentId]: studentRecordList
//         };
        
//         if (isEditing) {
//             setTempRecords(updatedRecords);
//         } else {
//             setStudentRecords(updatedRecords);
//         }
//     };

//     const handleSubmit = async () => {
//         try {
//             setSubmitting(true);
//             setValidationErrors({});
            
//             if (!students || students.length === 0) {
//                 toast.error("No students available");
//                 return;
//             }
            
//             const currentRecords = isEditing ? tempRecords : studentRecords;
//             const records = [];
            
//             // Build records array from all student scenarios
//             Object.keys(currentRecords).forEach(studentId => {
//                 const studentRecordList = currentRecords[studentId] || [];
//                 studentRecordList.forEach(record => {
//                     // Only save PASS/FAIL records (NOT_ATTEMPTED are not saved)
//                     if (record.result !== 'NOT_ATTEMPTED') {
//                         records.push({
//                             studentId: parseInt(studentId),
//                             batchId: parseInt(params.id),
//                             result: record.result,
//                             duration: record.duration || 15,
//                             scenario: record.scenario || 'Practice_Area',
//                             id: record.id || null,
//                             date: record.recordDate || dayjs().format('YYYY-MM-DD')
//                         });
//                     }
//                 });
//             });

//             if (records.length === 0) {
//                 toast.warning('No simulator records to save. Please add at least one PASS/FAIL scenario.');
//                 return;
//             }

//             const response = await markAllStudentSimulator(records);

//             if (response?.success) {
//                 toast.success(response.message || "Simulator data saved successfully!");
                
//                 if (isEditing) {
//                     setStudentRecords(JSON.parse(JSON.stringify(tempRecords)));
//                     setIsEditing(false);
//                 }
                
//                 // Refresh data
//                 await fetchAllSimulatorData();
//                 showSnackbar('Simulator data saved successfully', 'success');
                
//             } else {
//                 const errorMsg = response?.message || "Failed to save simulator data.";
//                 toast.error(errorMsg);
//             }

//         } catch (error) {
//             let errorMessage = "Error saving simulator data. Please try again.";
            
//             if (error.response?.status === 400) {
//                 const errorData = error.response.data;
//                 if (errorData.message) {
//                     errorMessage = `Error: ${errorData.message}`;
//                 }
//             } else if (error.response?.status === 401) {
//                 errorMessage = "Unauthorized. Please login again.";
//             } else if (error.response?.status === 403) {
//                 errorMessage = "You don't have permission to save simulator data.";
//             } else if (error.response?.status === 404) {
//                 errorMessage = "Batch or student not found.";
//             } else if (error.response?.status === 500) {
//                 errorMessage = "Server error. Please contact administrator.";
//             } else if (error.message) {
//                 errorMessage = `Network error: ${error.message}`;
//             }
            
//             toast.error(errorMessage);
//         } finally {
//             setSubmitting(false);
//         }
//     };

//     const showSnackbar = (message, severity) => {
//         setSnackbar({
//             open: true,
//             message,
//             severity
//         });
//     };

//     const handleCloseSnackbar = () => {
//         setSnackbar(prev => ({ ...prev, open: false }));
//     };

//     const getResultCounts = () => {
//         const counts = {
//             PASS: 0,
//             FAIL: 0,
//             NOT_ATTEMPTED: 0,
//             TOTAL: 0,
//             TOTAL_ATTEMPTED: 0
//         };

//         const currentRecords = isEditing ? tempRecords : studentRecords;
        
//         Object.values(currentRecords).forEach(recordList => {
//             recordList.forEach(record => {
//                 counts.TOTAL++;
//                 if (record.result === 'PASS') {
//                     counts.PASS++;
//                     counts.TOTAL_ATTEMPTED++;
//                 } else if (record.result === 'FAIL') {
//                     counts.FAIL++;
//                     counts.TOTAL_ATTEMPTED++;
//                 } else {
//                     counts.NOT_ATTEMPTED++;
//                 }
//             });
//         });

//         return counts;
//     };

//     const resultCounts = getResultCounts();

//     const handleSearchChange = (value) => {
//         setSearchTerm(value);

//         if (!value.trim()) {
//             setFilteredStudents(null);
//             return;
//         }

//         const searchLower = value.toLowerCase();
//         const filtered = students?.filter(student =>
//             student.id.toString().includes(searchLower) ||
//             student.firstName.toLowerCase().includes(searchLower) ||
//             student.lastName.toLowerCase().includes(searchLower)
//         );

//         setFilteredStudents(filtered || []);
//     };

//     const studentsToDisplay = filteredStudents !== null ? filteredStudents : students;

//     // Direct download without date selection
//     const handleDownloadExcel = async () => {
//         setLoader(true);
//         try {
//             const response = await downloadSimulatorExcel(params.id);
            
//             const blob = response.data;
//             const contentDisposition = response.headers['content-disposition'];
//             let filename = `Batch_${batchDetails?.batchName || params.id}_simulator_report.xlsx`;
//             if (contentDisposition) {
//                 const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
//                 if (filenameMatch && filenameMatch[1]) {
//                     filename = filenameMatch[1];
//                 }
//             }

//             const blobUrl = window.URL.createObjectURL(blob);
//             const link = document.createElement('a');
//             link.href = blobUrl;
//             link.setAttribute('download', filename);
//             document.body.appendChild(link);
//             link.click();
//             document.body.removeChild(link);
//             window.URL.revokeObjectURL(blobUrl);

//             toast.success('Simulator report downloaded successfully!');
            
//         } catch (error) {
//             console.error("Download failed:", error);
//             toast.error(`Error: ${error.message || 'Could not download the simulator report.'}`);
//         } finally {
//             setLoader(false);
//         }
//     };

//     const handleEditToggle = () => {
//         if (!canEditData) {
//             toast.error("You are not authorized to edit simulator data");
//             return;
//         }
        
//         if (isEditing) {
//             setTempRecords(JSON.parse(JSON.stringify(studentRecords)));
//             setIsEditing(false);
//             setValidationErrors({});
//             toast.info("Edit mode cancelled");
//         } else {
//             setTempRecords(JSON.parse(JSON.stringify(studentRecords)));
//             setIsEditing(true);
//             toast.info("Edit mode enabled - You can now add/remove scenarios");
//         }
//     };

//     const toggleStudentExpand = (studentId) => {
//         setExpandedStudents(prev => ({
//             ...prev,
//             [studentId]: !prev[studentId]
//         }));
//     };

//     const getCurrentRecords = (studentId) => {
//         const currentRecords = isEditing ? tempRecords : studentRecords;
//         return currentRecords[studentId] || [];
//     };

//     const getResultColor = (result) => {
//         switch(result) {
//             case 'PASS': return 'success';
//             case 'FAIL': return 'error';
//             default: return 'default';
//         }
//     };

//     const getResultLabel = (result) => {
//         const option = RESULT_OPTIONS.find(r => r.value === result);
//         return option ? option.label : result;
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return 'N/A';
//         return dayjs(dateString).format('DD MMM YYYY HH:mm');
//     };

//     // Delete a single scenario record
//     const handleDeleteScenario = async (studentId, recordId, index) => {
//         if (!recordId) {
//             // If it's a new record (no ID), just remove it from UI
//             handleRemoveScenario(studentId, index);
//             return;
//         }
        
//         if (!window.confirm('Are you sure you want to delete this scenario record?')) {
//             return;
//         }
        
//         try {
//             setLoading(true);
//             const response = await deleteSimulatorRecord(recordId);
//             if (response?.success) {
//                 toast.success('Scenario record deleted successfully');
//                 await fetchAllSimulatorData();
//             } else {
//                 toast.error(response?.message || 'Failed to delete record');
//             }
//         } catch (error) {
//             toast.error('Error deleting record: ' + error.message);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleDeleteStudentRecords = async (studentId) => {
//         if (!window.confirm('Are you sure you want to delete all simulator records for this student?')) {
//             return;
//         }
        
//         try {
//             setLoading(true);
//             const response = await deleteStudentSimulatorRecords(studentId);
//             if (response?.success) {
//                 toast.success('Simulator records deleted successfully for student');
//                 await fetchAllSimulatorData();
//             } else {
//                 toast.error(response?.message || 'Failed to delete records');
//             }
//         } catch (error) {
//             toast.error('Error deleting records: ' + error.message);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleDeleteBatchRecords = async () => {
//         if (!window.confirm('Are you sure you want to delete ALL simulator records for this batch? This action cannot be undone.')) {
//             return;
//         }
        
//         try {
//             setLoading(true);
//             const response = await deleteBatchSimulatorRecords(params.id);
//             if (response?.success) {
//                 toast.success('All simulator records deleted successfully for this batch');
//                 await fetchAllSimulatorData();
//             } else {
//                 toast.error(response?.message || 'Failed to delete records');
//             }
//         } catch (error) {
//             toast.error('Error deleting records: ' + error.message);
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <Paper elevation={3} sx={{ p: 3 }}>
//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//                 <Typography variant="h5" component="h2">
//                     Simulator Candidates (One-Time Activity)
//                     {isEditing && (
//                         <Chip 
//                             label="Edit Mode" 
//                             color="warning" 
//                             size="small" 
//                             sx={{ ml: 2, verticalAlign: 'middle' }}
//                         />
//                     )}
//                 </Typography>

//                 <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
//                     {lastUpdated && (
//                         <Typography variant="caption" color="textSecondary">
//                             Last Updated: {formatDate(lastUpdated)}
//                         </Typography>
//                     )}

//                     <Tooltip title={isEditing ? "Cancel Edit" : canEditData ? "Edit Data" : "Edit not allowed for your role"}>
//                         <span>
//                             <IconButton
//                                 onClick={handleEditToggle}
//                                 color={isEditing ? "warning" : "primary"}
//                                 disabled={loading || submitting || !canEditData}
//                             >
//                                 {isEditing ? <CancelIcon /> : <EditIcon />}
//                             </IconButton>
//                         </span>
//                     </Tooltip>

//                     {isEditing && canEditData && (
//                         <Tooltip title="Delete all records for this batch">
//                             <IconButton
//                                 onClick={handleDeleteBatchRecords}
//                                 color="error"
//                                 disabled={loading || submitting}
//                             >
//                                 <DeleteIcon />
//                             </IconButton>
//                         </Tooltip>
//                     )}

//                     <Button
//                         variant="contained"
//                         onClick={handleDownloadExcel}
//                         size="small"
//                         startIcon={loader ? <CircularProgress size={20} /> : <FileDownloadIcon />}
//                         disabled={loader || loading}
//                     >
//                         {loader ? 'Downloading...' : 'Download Report'}
//                     </Button>
//                 </Box>
//             </Box>

//             {/* Summary Statistics */}
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
//                 <Paper sx={{ p: 2, flex: 1, minWidth: 100, bgcolor: '#f5f5f5' }}>
//                     <Typography variant="caption" color="textSecondary">Total Students</Typography>
//                     <Typography variant="h6">{students?.length || 0}</Typography>
//                 </Paper>
//                 <Paper sx={{ p: 2, flex: 1, minWidth: 100, bgcolor: '#e8f5e9' }}>
//                     <Typography variant="caption" color="textSecondary">Total Pass</Typography>
//                     <Typography variant="h6" color="success.main">{resultCounts.PASS}</Typography>
//                 </Paper>
//                 <Paper sx={{ p: 2, flex: 1, minWidth: 100, bgcolor: '#ffebee' }}>
//                     <Typography variant="caption" color="textSecondary">Total Fail</Typography>
//                     <Typography variant="h6" color="error.main">{resultCounts.FAIL}</Typography>
//                 </Paper>
//                 <Paper sx={{ p: 2, flex: 1, minWidth: 100, bgcolor: '#fff3e0' }}>
//                     <Typography variant="caption" color="textSecondary">Not Attempted</Typography>
//                     <Typography variant="h6" color="textSecondary">{resultCounts.NOT_ATTEMPTED}</Typography>
//                 </Paper>
//                 <Paper sx={{ p: 2, flex: 1, minWidth: 100, bgcolor: '#e3f2fd' }}>
//                     <Typography variant="caption" color="textSecondary">Total Attempted</Typography>
//                     <Typography variant="h6">{resultCounts.TOTAL_ATTEMPTED}</Typography>
//                 </Paper>
//                 <Paper sx={{ p: 2, flex: 1, minWidth: 100, bgcolor: '#fce4ec' }}>
//                     <Typography variant="caption" color="textSecondary">Pass Rate</Typography>
//                     <Typography variant="h6">
//                         {resultCounts.TOTAL_ATTEMPTED > 0 
//                             ? `${Math.round((resultCounts.PASS / resultCounts.TOTAL_ATTEMPTED) * 100)}%` 
//                             : '0%'}
//                     </Typography>
//                 </Paper>
//             </Box>

//             {loading && <LinearProgress />}

//             <Box display="flex" justifyContent="space-between" sx={{ mb: 2 }}>
//                 <TextField
//                     label="Search Students"
//                     variant="outlined"
//                     value={searchTerm}
//                     onChange={(e) => handleSearchChange(e.target.value)}
//                     sx={{ width: '400px' }}
//                     disabled={loading}
//                 />
//                 <Typography variant="caption" color="textSecondary" sx={{ alignSelf: 'center' }}>
//                     <strong>Note:</strong> This is a one-time activity. Each student's simulator attempt is recorded once.
//                     <br />
//                     <strong>Click "Download Report"</strong> to export all simulator records for this batch.
//                 </Typography>
//             </Box>
            
//             <TableContainer component={Paper} sx={{ maxHeight: '70vh', overflow: 'auto' }}>
//                 <Table stickyHeader>
//                     <TableHead>
//                         <TableRow sx={{ bgcolor: '#f5f5f5' }}>
//                             <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold' }}>Student ID</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold' }}>Scenarios</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {studentsToDisplay?.length > 0 ? (
//                             studentsToDisplay?.map((student, index) => {
//                                 const records = getCurrentRecords(student.id);
//                                 const isExpanded = expandedStudents[student.id] || false;
//                                 const hasAttempted = records.some(r => r.result !== 'NOT_ATTEMPTED');
//                                 const passCount = records.filter(r => r.result === 'PASS').length;
//                                 const failCount = records.filter(r => r.result === 'FAIL').length;
                                
//                                 return (
//                                     <React.Fragment key={student.id}>
//                                         <TableRow 
//                                             sx={{ 
//                                                 bgcolor: 'transparent',
//                                                 '&:hover': { bgcolor: 'action.hover' }
//                                             }}
//                                         >
//                                             <TableCell>{index + 1}</TableCell>
//                                             <TableCell>{student.id}</TableCell>
//                                             <TableCell>{`${student.firstName} ${student.lastName}`}</TableCell>
//                                             <TableCell>
//                                                 <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                                                     {records.map((record, idx) => (
//                                                         <Chip
//                                                             key={idx}
//                                                             label={`${SCENARIO_OPTIONS.find(s => s.value === record.scenario)?.label || record.scenario}: ${getResultLabel(record.result)}`}
//                                                             color={getResultColor(record.result)}
//                                                             size="small"
//                                                             variant={record.result === 'NOT_ATTEMPTED' ? 'outlined' : 'filled'}
//                                                         />
//                                                     ))}
//                                                 </Box>
//                                             </TableCell>
//                                             <TableCell>
//                                                 {hasAttempted ? (
//                                                     <Chip 
//                                                         label="Attempted" 
//                                                         color="primary" 
//                                                         size="small"
//                                                         icon={passCount > failCount ? <CheckCircleIcon /> : <CancelIconRed />}
//                                                     />
//                                                 ) : (
//                                                     <Chip 
//                                                         label="Not Attempted" 
//                                                         color="default" 
//                                                         size="small"
//                                                         variant="outlined"
//                                                     />
//                                                 )}
//                                             </TableCell>
//                                             <TableCell>
//                                                 <Box sx={{ display: 'flex', gap: 1 }}>
//                                                     <Button
//                                                         size="small"
//                                                         onClick={() => toggleStudentExpand(student.id)}
//                                                         startIcon={<ExpandMoreIcon sx={{ transform: isExpanded ? 'rotate(180deg)' : 'none' }} />}
//                                                     >
//                                                         {isExpanded ? 'Hide' : 'View'}
//                                                     </Button>
//                                                 </Box>
//                                             </TableCell>
//                                         </TableRow>
//                                         {isExpanded && (
//                                             <TableRow>
//                                                 <TableCell colSpan={6} sx={{ bgcolor: '#fafafa' }}>
//                                                     <Box sx={{ p: 2 }}>
//                                                         <Typography variant="subtitle2" sx={{ mb: 2 }}>
//                                                             Simulator Scenarios for {student.firstName} {student.lastName}
//                                                             <Chip 
//                                                                 size="small" 
//                                                                 label={hasAttempted ? "Attempted" : "Not Attempted"}
//                                                                 color={hasAttempted ? "primary" : "default"}
//                                                                 sx={{ ml: 2 }}
//                                                             />
//                                                         </Typography>
//                                                         <Table size="small">
//                                                             <TableHead>
//                                                                 <TableRow>
//                                                                     <TableCell>#</TableCell>
//                                                                     <TableCell>Scenario</TableCell>
//                                                                     <TableCell>Result</TableCell>
//                                                                     <TableCell>Duration (min)</TableCell>
//                                                                     <TableCell>Status</TableCell>
//                                                                     <TableCell>Action</TableCell>
//                                                                 </TableRow>
//                                                             </TableHead>
//                                                             <TableBody>
//                                                                 {records.map((record, idx) => (
//                                                                     <TableRow key={idx}>
//                                                                         <TableCell>{idx + 1}</TableCell>
//                                                                         <TableCell>
//                                                                             {isEditing ? (
//                                                                                 <FormControl size="small" sx={{ minWidth: 150 }}>
//                                                                                     <Select
//                                                                                         value={record.scenario}
//                                                                                         onChange={(e) => handleRecordChange(student.id, idx, 'scenario', e.target.value)}
//                                                                                         disabled={submitting || !canEditData}
//                                                                                     >
//                                                                                         {SCENARIO_OPTIONS.map((option) => (
//                                                                                             <MenuItem key={option.value} value={option.value}>
//                                                                                                 {option.label}
//                                                                                             </MenuItem>
//                                                                                         ))}
//                                                                                     </Select>
//                                                                                 </FormControl>
//                                                                             ) : (
//                                                                                 <Typography variant="body2">
//                                                                                     {SCENARIO_OPTIONS.find(s => s.value === record.scenario)?.label || record.scenario}
//                                                                                 </Typography>
//                                                                             )}
//                                                                         </TableCell>
//                                                                         <TableCell>
//                                                                             {isEditing ? (
//                                                                                 <FormControl size="small" sx={{ minWidth: 120 }}>
//                                                                                     <Select
//                                                                                         value={record.result}
//                                                                                         onChange={(e) => handleRecordChange(student.id, idx, 'result', e.target.value)}
//                                                                                         disabled={submitting || !canEditData}
//                                                                                     >
//                                                                                         <MenuItem value="NOT_ATTEMPTED">Not Attempted</MenuItem>
//                                                                                         <MenuItem value="PASS">Pass</MenuItem>
//                                                                                         <MenuItem value="FAIL">Fail</MenuItem>
//                                                                                     </Select>
//                                                                                 </FormControl>
//                                                                             ) : (
//                                                                                 <Chip
//                                                                                     label={getResultLabel(record.result)}
//                                                                                     color={getResultColor(record.result)}
//                                                                                     size="small"
//                                                                                     icon={record.result === 'PASS' ? <CheckCircleIcon /> : 
//                                                                                           record.result === 'FAIL' ? <CancelIconRed /> : null}
//                                                                                     variant={record.result === 'NOT_ATTEMPTED' ? 'outlined' : 'filled'}
//                                                                                 />
//                                                                             )}
//                                                                         </TableCell>
//                                                                         <TableCell>
//                                                                             {isEditing ? (
//                                                                                 <TextField
//                                                                                     type="number"
//                                                                                     value={record.duration}
//                                                                                     onChange={(e) => handleRecordChange(student.id, idx, 'duration', parseInt(e.target.value) || 0)}
//                                                                                     size="small"
//                                                                                     sx={{ width: 80 }}
//                                                                                     InputProps={{ inputProps: { min: 0 } }}
//                                                                                     disabled={submitting || !canEditData}
//                                                                                 />
//                                                                             ) : (
//                                                                                 <Typography variant="body2">{record.duration} min</Typography>
//                                                                             )}
//                                                                         </TableCell>
//                                                                         <TableCell>
//                                                                             {record.isNew ? (
//                                                                                 <Chip label="New" size="small" color="info" />
//                                                                             ) : (
//                                                                                 <Chip label="Saved" size="small" color="success" variant="outlined" />
//                                                                             )}
//                                                                         </TableCell>
//                                                                         <TableCell>
//                                                                             {isEditing && (
//                                                                                 <>
//                                                                                     {record.id ? (
//                                                                                         <IconButton
//                                                                                             size="small"
//                                                                                             color="error"
//                                                                                             onClick={() => handleDeleteScenario(student.id, record.id, idx)}
//                                                                                             disabled={submitting || !canEditData}
//                                                                                             title="Delete this scenario record"
//                                                                                         >
//                                                                                             <DeleteIcon />
//                                                                                         </IconButton>
//                                                                                     ) : (
//                                                                                         <IconButton
//                                                                                             size="small"
//                                                                                             color="error"
//                                                                                             onClick={() => handleRemoveScenario(student.id, idx)}
//                                                                                             disabled={submitting || !canEditData || records.length <= 1}
//                                                                                             title="Remove this scenario"
//                                                                                         >
//                                                                                             <DeleteIcon />
//                                                                                         </IconButton>
//                                                                                     )}
//                                                                                 </>
//                                                                             )}
//                                                                         </TableCell>
//                                                                     </TableRow>
//                                                                 ))}
//                                                                 {isEditing && (
//                                                                     <TableRow>
//                                                                         <TableCell colSpan={6}>
//                                                                             <Button
//                                                                                 size="small"
//                                                                                 startIcon={<AddIcon />}
//                                                                                 onClick={() => handleAddScenario(student.id)}
//                                                                                 disabled={submitting || !canEditData}
//                                                                             >
//                                                                                 Add Scenario
//                                                                             </Button>
//                                                                             <Button
//                                                                                 size="small"
//                                                                                 color="error"
//                                                                                 startIcon={<DeleteIcon />}
//                                                                                 onClick={() => handleDeleteStudentRecords(student.id)}
//                                                                                 disabled={submitting || !canEditData}
//                                                                                 sx={{ ml: 1 }}
//                                                                             >
//                                                                                 Delete All Student Records
//                                                                             </Button>
//                                                                         </TableCell>
//                                                                     </TableRow>
//                                                                 )}
//                                                             </TableBody>
//                                                         </Table>
//                                                     </Box>
//                                                 </TableCell>
//                                             </TableRow>
//                                         )}
//                                     </React.Fragment>
//                                 );
//                             })
//                         ) : (
//                             <TableRow>
//                                 <TableCell colSpan={6} align="center">
//                                     {filteredStudents?.length === 0 ? 'No matching students found' : 'No students available'}
//                                 </TableCell>
//                             </TableRow>
//                         )}
//                     </TableBody>
//                 </Table>
//             </TableContainer>

//             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
//                 <Box>
//                     {isEditing && (
//                         <Typography variant="body2" component="div" color="warning.main">
//                             <strong>Note:</strong> You are in edit mode. You can add/remove scenarios for each student.
//                             <br />
//                             <strong>Delete Scenario:</strong> Click the delete icon next to a scenario to remove it.
//                             <br />
//                             <strong>Delete Student:</strong> Click "Delete All Student Records" to remove all scenarios for a student.
//                             <br />
//                             <strong>Batch Delete:</strong> Click the delete icon in the header to remove all records for this batch.
//                         </Typography>
//                     )}
//                     <Typography variant="caption" color="textSecondary">
//                         <strong>Tip:</strong> Click "View" to see all scenarios for a student. Only PASS/FAIL records will be saved.
//                         <br />
//                         <strong>One-Time Activity:</strong> Each student's simulator attempt is recorded once and can be updated.
//                     </Typography>
//                 </Box>
//                 <Box sx={{ display: 'flex', gap: 1 }}>
//                     {isEditing && (
//                         <Button
//                             variant="outlined"
//                             onClick={handleEditToggle}
//                             disabled={loading || submitting}
//                             startIcon={<CancelIcon />}
//                         >
//                             Cancel Edit
//                         </Button>
//                     )}
//                     <Button
//                         variant="contained"
//                         onClick={handleSubmit}
//                         disabled={loading || submitting || !canEditData}
//                         size="large"
//                         startIcon={isEditing ? <SaveIcon /> : null}
//                         color={isEditing ? "warning" : "primary"}
//                     >
//                         {submitting ? 'Saving...' : isEditing ? 'Update' : 'Save'}
//                     </Button>
//                 </Box>
//             </Box>

//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={6000}
//                 onClose={handleCloseSnackbar}
//                 anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
//             >
//                 <Alert
//                     onClose={handleCloseSnackbar}
//                     severity={snackbar.severity}
//                     sx={{ width: '100%' }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Paper>
//     );
// };

// export default Simulator;




// Simulator.jsx
import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    TextField,
    Typography,
    Box,
    LinearProgress,
    Snackbar,
    Alert,
    Chip,
    Modal,
    Select,
    MenuItem,
    FormControl,
    IconButton,
    Tooltip,
    InputLabel,
    Grid,
    Divider,
    CircularProgress,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIconRed from '@mui/icons-material/Cancel';
import AssessmentIcon from '@mui/icons-material/Assessment';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    markAllStudentSimulator,
    getAllStudentSimulator,
    getSimulatorStatistics,
    downloadSimulatorExcel,
    deleteStudentSimulatorRecords,
    deleteBatchSimulatorRecords,
    deleteSimulatorRecord
} from '../../../helpers/simulator_helper';

const SCENARIO_OPTIONS = [
    { value: 'City_Driving', label: 'City Driving' },
    { value: 'Highway_Driving', label: 'Highway Driving' },
    { value: 'Practice_Area', label: 'Practice Area' },
    { value: 'Country_Driving', label: 'Country Driving' },
    { value: 'Hill_Driving', label: 'Hill Driving' },
    { value: 'External Training', label: 'External Training' },
];

// Result options
const RESULT_OPTIONS = [
    { value: 'NOT_ATTEMPTED', label: 'Not Attempted', color: 'default' },
    { value: 'PASS', label: 'Pass', color: 'success' },
    { value: 'FAIL', label: 'Fail', color: 'error' },
];

// Users who can edit data
const ALLOW_EDIT_USERS = ['Admin', 'Super Admin', 'Project Manager', 'Tata Project Manager', 'Trainer', 'Tata Trainer'];

// Users who can delete data (Admin and Project Manager only)
const ALLOW_DELETE_USERS = ['Admin', 'Super Admin', 'Project Manager', 'Tata Project Manager'];

const Simulator = ({ students, batchDetails }) => {
    // Store multiple scenarios per student
    const [studentRecords, setStudentRecords] = useState({});
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const params = useParams();
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });
    
    const [isEditing, setIsEditing] = useState(false);
    const [tempRecords, setTempRecords] = useState({});
    const [userType, setUserType] = useState('');
    const [canEditData, setCanEditData] = useState(false);
    const [canDeleteData, setCanDeleteData] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const [filteredStudents, setFilteredStudents] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [loader, setLoader] = useState(false);
    const [statistics, setStatistics] = useState(null);
    const [expandedStudents, setExpandedStudents] = useState({});
    const [lastUpdated, setLastUpdated] = useState(null);

    useEffect(() => {
        const authUser = JSON.parse(localStorage.getItem('authUser'));
        const currentUserType = authUser?.userType || '';
        setUserType(currentUserType);
        setCanEditData(ALLOW_EDIT_USERS.includes(currentUserType));
        setCanDeleteData(ALLOW_DELETE_USERS.includes(currentUserType));
    }, []);

    // Fetch all simulator data for the batch (no date filter - one-time activity)
    const fetchAllSimulatorData = async () => {
        if (!students || students.length === 0) return;

        try {
            setLoading(true);
            setIsEditing(false);
            setValidationErrors({});
            setStatistics(null);

            // Fetch all simulator records for this batch (no date parameter)
            const response = await getAllStudentSimulator(params.id);
            
            const fetchedRecords = {};
            
            // Initialize each student with default records
            students.forEach(student => {
                fetchedRecords[student.id] = [
                    {
                        id: null,
                        scenario: 'Practice_Area',
                        result: 'NOT_ATTEMPTED',
                        duration: 15,
                        isNew: true,
                        createdAt: null,
                        updatedAt: null,
                        recordDate: null
                    }
                ];
            });
            
            if (response?.success && response?.result && Array.isArray(response.result)) {
                // Group records by student ID
                const recordsByStudent = {};
                response.result.forEach(record => {
                    if (record.studentId) {
                        if (!recordsByStudent[record.studentId]) {
                            recordsByStudent[record.studentId] = [];
                        }
                        recordsByStudent[record.studentId].push({
                            id: record.id,
                            scenario: record.scenario || 'Practice_Area',
                            result: record.result || 'NOT_ATTEMPTED',
                            duration: record.duration || 15,
                            isNew: false,
                            createdAt: record.entryAt || record.createdAt,
                            updatedAt: record.updatedAt,
                            recordDate: record.date
                        });
                    }
                });
                
                // Update fetched records with actual data
                Object.keys(recordsByStudent).forEach(studentId => {
                    if (fetchedRecords[studentId]) {
                        fetchedRecords[studentId] = recordsByStudent[studentId];
                    }
                });

                // Get last updated timestamp
                const lastUpdatedRecord = response.result.reduce((latest, record) => {
                    if (!latest || (record.updatedAt && record.updatedAt > latest.updatedAt)) {
                        return record;
                    }
                    return latest;
                }, null);
                
                if (lastUpdatedRecord) {
                    setLastUpdated(lastUpdatedRecord.updatedAt);
                }
            }

            setStudentRecords(fetchedRecords);
            setTempRecords(JSON.parse(JSON.stringify(fetchedRecords)));

            // Fetch statistics (no date filter)
            try {
                const statsResponse = await getSimulatorStatistics(params.id);
                if (statsResponse?.success && statsResponse?.statistics) {
                    setStatistics(statsResponse.statistics);
                }
            } catch (statsError) {
                console.log('Statistics not available');
            }

        } catch (error) {
            console.error('Error in fetchAllSimulatorData:', error);
            const defaultRecords = {};
            students?.forEach(student => {
                defaultRecords[student.id] = [
                    {
                        id: null,
                        scenario: 'Practice_Area',
                        result: 'NOT_ATTEMPTED',
                        duration: 15,
                        isNew: true,
                        createdAt: null,
                        updatedAt: null,
                        recordDate: null
                    }
                ];
            });
            setStudentRecords(defaultRecords);
            setTempRecords(JSON.parse(JSON.stringify(defaultRecords)));
            toast.error('Error fetching simulator data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (params.id && students && students.length > 0) {
            fetchAllSimulatorData();
        }
    }, [params.id, students]);

    const handleAddScenario = (studentId) => {
        const currentRecords = isEditing ? tempRecords : studentRecords;
        const studentRecordList = currentRecords[studentId] || [];
        
        // Check if there's already a "NOT_ATTEMPTED" record
        const hasNotAttempted = studentRecordList.some(r => r.result === 'NOT_ATTEMPTED');
        
        const newRecord = {
            id: null,
            scenario: 'Practice_Area',
            result: hasNotAttempted ? 'PASS' : 'NOT_ATTEMPTED',
            duration: 15,
            isNew: true,
            createdAt: null,
            updatedAt: null,
            recordDate: dayjs().format('YYYY-MM-DD')
        };
        
        const updatedRecords = {
            ...currentRecords,
            [studentId]: [...studentRecordList, newRecord]
        };
        
        if (isEditing) {
            setTempRecords(updatedRecords);
        } else {
            setStudentRecords(updatedRecords);
        }
    };

    const handleRemoveScenario = (studentId, index) => {
        const currentRecords = isEditing ? tempRecords : studentRecords;
        const studentRecordList = currentRecords[studentId] || [];
        
        if (studentRecordList.length <= 1) {
            toast.warning('Each student must have at least one scenario');
            return;
        }
        
        const updatedList = studentRecordList.filter((_, i) => i !== index);
        const updatedRecords = {
            ...currentRecords,
            [studentId]: updatedList
        };
        
        if (isEditing) {
            setTempRecords(updatedRecords);
        } else {
            setStudentRecords(updatedRecords);
        }
    };

    const handleRecordChange = (studentId, index, field, value) => {
        const currentRecords = isEditing ? tempRecords : studentRecords;
        const studentRecordList = [...(currentRecords[studentId] || [])];
        
        if (field === 'result' && value !== 'NOT_ATTEMPTED') {
            // If setting PASS or FAIL, check if there's already a NOT_ATTEMPTED record
            // and it's not the current one
            const hasNotAttempted = studentRecordList.some((r, i) => 
                i !== index && r.result === 'NOT_ATTEMPTED'
            );
            if (hasNotAttempted) {
                // Remove the NOT_ATTEMPTED record
                const notAttemptedIndex = studentRecordList.findIndex((r, i) => 
                    i !== index && r.result === 'NOT_ATTEMPTED'
                );
                if (notAttemptedIndex !== -1) {
                    studentRecordList.splice(notAttemptedIndex, 1);
                }
            }
        }
        
        studentRecordList[index] = {
            ...studentRecordList[index],
            [field]: value,
            // If result is changed from NOT_ATTEMPTED, mark as not new
            isNew: studentRecordList[index].isNew && value === 'NOT_ATTEMPTED'
        };
        
        const updatedRecords = {
            ...currentRecords,
            [studentId]: studentRecordList
        };
        
        if (isEditing) {
            setTempRecords(updatedRecords);
        } else {
            setStudentRecords(updatedRecords);
        }
    };

    const handleSubmit = async () => {
        try {
            setSubmitting(true);
            setValidationErrors({});
            
            if (!students || students.length === 0) {
                toast.error("No students available");
                return;
            }
            
            const currentRecords = isEditing ? tempRecords : studentRecords;
            const records = [];
            
            // Build records array from all student scenarios
            Object.keys(currentRecords).forEach(studentId => {
                const studentRecordList = currentRecords[studentId] || [];
                studentRecordList.forEach(record => {
                    // Only save PASS/FAIL records (NOT_ATTEMPTED are not saved)
                    if (record.result !== 'NOT_ATTEMPTED') {
                        records.push({
                            studentId: parseInt(studentId),
                            batchId: parseInt(params.id),
                            result: record.result,
                            duration: record.duration || 15,
                            scenario: record.scenario || 'Practice_Area',
                            id: record.id || null,
                            date: record.recordDate || dayjs().format('YYYY-MM-DD')
                        });
                    }
                });
            });

            if (records.length === 0) {
                toast.warning('No simulator records to save. Please add at least one PASS/FAIL scenario.');
                return;
            }

            const response = await markAllStudentSimulator(records);

            if (response?.success) {
                toast.success(response.message || "Simulator data saved successfully!");
                
                if (isEditing) {
                    setStudentRecords(JSON.parse(JSON.stringify(tempRecords)));
                    setIsEditing(false);
                }
                
                // Refresh data
                await fetchAllSimulatorData();
                showSnackbar('Simulator data saved successfully', 'success');
                
            } else {
                const errorMsg = response?.message || "Failed to save simulator data.";
                toast.error(errorMsg);
            }

        } catch (error) {
            let errorMessage = "Error saving simulator data. Please try again.";
            
            if (error.response?.status === 400) {
                const errorData = error.response.data;
                if (errorData.message) {
                    errorMessage = `Error: ${errorData.message}`;
                }
            } else if (error.response?.status === 401) {
                errorMessage = "Unauthorized. Please login again.";
            } else if (error.response?.status === 403) {
                errorMessage = "You don't have permission to save simulator data.";
            } else if (error.response?.status === 404) {
                errorMessage = "Batch or student not found.";
            } else if (error.response?.status === 500) {
                errorMessage = "Server error. Please contact administrator.";
            } else if (error.message) {
                errorMessage = `Network error: ${error.message}`;
            }
            
            toast.error(errorMessage);
        } finally {
            setSubmitting(false);
        }
    };

    const showSnackbar = (message, severity) => {
        setSnackbar({
            open: true,
            message,
            severity
        });
    };

    const handleCloseSnackbar = () => {
        setSnackbar(prev => ({ ...prev, open: false }));
    };

    const getResultCounts = () => {
        const counts = {
            PASS: 0,
            FAIL: 0,
            NOT_ATTEMPTED: 0,
            TOTAL: 0,
            TOTAL_ATTEMPTED: 0
        };

        const currentRecords = isEditing ? tempRecords : studentRecords;
        
        Object.values(currentRecords).forEach(recordList => {
            recordList.forEach(record => {
                counts.TOTAL++;
                if (record.result === 'PASS') {
                    counts.PASS++;
                    counts.TOTAL_ATTEMPTED++;
                } else if (record.result === 'FAIL') {
                    counts.FAIL++;
                    counts.TOTAL_ATTEMPTED++;
                } else {
                    counts.NOT_ATTEMPTED++;
                }
            });
        });

        return counts;
    };

    const resultCounts = getResultCounts();

    const handleSearchChange = (value) => {
        setSearchTerm(value);

        if (!value.trim()) {
            setFilteredStudents(null);
            return;
        }

        const searchLower = value.toLowerCase();
        const filtered = students?.filter(student =>
            student.id.toString().includes(searchLower) ||
            student.firstName.toLowerCase().includes(searchLower) ||
            student.lastName.toLowerCase().includes(searchLower)
        );

        setFilteredStudents(filtered || []);
    };

    const studentsToDisplay = filteredStudents !== null ? filteredStudents : students;

    // Direct download without date selection
    const handleDownloadExcel = async () => {
        setLoader(true);
        try {
            const response = await downloadSimulatorExcel(params.id);
            
            const blob = response.data;
            const contentDisposition = response.headers['content-disposition'];
            let filename = `Batch_${batchDetails?.batchName || params.id}_simulator_report.xlsx`;
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1];
                }
            }

            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);

            toast.success('Simulator report downloaded successfully!');
            
        } catch (error) {
            console.error("Download failed:", error);
            toast.error(`Error: ${error.message || 'Could not download the simulator report.'}`);
        } finally {
            setLoader(false);
        }
    };

    const handleEditToggle = () => {
        if (!canEditData) {
            toast.error("You are not authorized to edit simulator data");
            return;
        }
        
        if (isEditing) {
            setTempRecords(JSON.parse(JSON.stringify(studentRecords)));
            setIsEditing(false);
            setValidationErrors({});
            toast.info("Edit mode cancelled");
        } else {
            setTempRecords(JSON.parse(JSON.stringify(studentRecords)));
            setIsEditing(true);
            toast.info("Edit mode enabled - You can now add/remove scenarios");
        }
    };

    const toggleStudentExpand = (studentId) => {
        setExpandedStudents(prev => ({
            ...prev,
            [studentId]: !prev[studentId]
        }));
    };

    const getCurrentRecords = (studentId) => {
        const currentRecords = isEditing ? tempRecords : studentRecords;
        return currentRecords[studentId] || [];
    };

    const getResultColor = (result) => {
        switch(result) {
            case 'PASS': return 'success';
            case 'FAIL': return 'error';
            default: return 'default';
        }
    };

    const getResultLabel = (result) => {
        const option = RESULT_OPTIONS.find(r => r.value === result);
        return option ? option.label : result;
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return dayjs(dateString).format('DD MMM YYYY HH:mm');
    };

    // Delete a single scenario record - Only Admin/Project Manager
    const handleDeleteScenario = async (studentId, recordId, index) => {
        // Check if user has delete permission
        if (!canDeleteData) {
            toast.error('You do not have permission to delete simulator records. Only Admin and Project Manager can delete records.');
            return;
        }
        
        if (!recordId) {
            // If it's a new record (no ID), just remove it from UI
            handleRemoveScenario(studentId, index);
            return;
        }
        
        if (!window.confirm('Are you sure you want to delete this scenario record?')) {
            return;
        }
        
        try {
            setLoading(true);
            const response = await deleteSimulatorRecord(recordId);
            if (response?.success) {
                toast.success('Scenario record deleted successfully');
                await fetchAllSimulatorData();
            } else {
                toast.error(response?.message || 'Failed to delete record');
            }
        } catch (error) {
            toast.error('Error deleting record: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    // Delete all records for a student - Only Admin/Project Manager
    const handleDeleteStudentRecords = async (studentId) => {
        // Check if user has delete permission
        if (!canDeleteData) {
            toast.error('You do not have permission to delete simulator records. Only Admin and Project Manager can delete records.');
            return;
        }
        
        if (!window.confirm('Are you sure you want to delete all simulator records for this student?')) {
            return;
        }
        
        try {
            setLoading(true);
            const response = await deleteStudentSimulatorRecords(studentId);
            if (response?.success) {
                toast.success('Simulator records deleted successfully for student');
                await fetchAllSimulatorData();
            } else {
                toast.error(response?.message || 'Failed to delete records');
            }
        } catch (error) {
            toast.error('Error deleting records: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    // Delete all records for the batch - Only Admin/Project Manager
    const handleDeleteBatchRecords = async () => {
        // Check if user has delete permission
        if (!canDeleteData) {
            toast.error('You do not have permission to delete simulator records. Only Admin and Project Manager can delete records.');
            return;
        }
        
        if (!window.confirm('Are you sure you want to delete ALL simulator records for this batch? This action cannot be undone.')) {
            return;
        }
        
        try {
            setLoading(true);
            const response = await deleteBatchSimulatorRecords(params.id);
            if (response?.success) {
                toast.success('All simulator records deleted successfully for this batch');
                await fetchAllSimulatorData();
            } else {
                toast.error(response?.message || 'Failed to delete records');
            }
        } catch (error) {
            toast.error('Error deleting records: ' + error.message);
        } finally {
            setLoading(false);
        }
    };

    // Permission Info Card component
    const PermissionInfoCard = () => (
        <Paper sx={{ p: 2, mb: 3, bgcolor: 'info.light', borderRadius: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box>
                    <Typography variant="subtitle2" component="div" color="info.dark">
                        <strong>User Role:</strong> {userType || 'Loading...'}
                    </Typography>
                    <Typography variant="caption" component="div" color="info.dark">
                        <strong>Permissions:</strong> 
                        {canEditData ? ' ✅ Can edit data' : ' ❌ Cannot edit data'}
                        {canDeleteData ? ' | ✅ Can delete data' : ' | ❌ Cannot delete data'}
                        {canDeleteData && ' (Admin & Project Manager only)'}
                    </Typography>
                </Box>
                {!canDeleteData && (
                    <Chip 
                        label="Read Only Mode" 
                        color="warning" 
                        size="small"
                    />
                )}
            </Box>
        </Paper>
    );

    return (
        <Paper elevation={3} sx={{ p: 3 }}>
            {/* Permission Info Card */}
            <PermissionInfoCard />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Typography variant="h5" component="h2">
                    Simulator Candidates (One-Time Activity)
                    {isEditing && (
                        <Chip 
                            label="Edit Mode" 
                            color="warning" 
                            size="small" 
                            sx={{ ml: 2, verticalAlign: 'middle' }}
                        />
                    )}
                </Typography>

                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    {lastUpdated && (
                        <Typography variant="caption" color="textSecondary">
                            Last Updated: {formatDate(lastUpdated)}
                        </Typography>
                    )}

                    <Tooltip title={isEditing ? "Cancel Edit" : canEditData ? "Edit Data" : "Edit not allowed for your role"}>
                        <span>
                            <IconButton
                                onClick={handleEditToggle}
                                color={isEditing ? "warning" : "primary"}
                                disabled={loading || submitting || !canEditData}
                            >
                                {isEditing ? <CancelIcon /> : <EditIcon />}
                            </IconButton>
                        </span>
                    </Tooltip>

                    {/* Delete Batch Records - Only visible to Admin/Project Manager */}
                    {isEditing && canDeleteData && (
                        <Tooltip title={canDeleteData ? "Delete all records for this batch" : "Only Admin and Project Manager can delete records"}>
                            <span>
                                <IconButton
                                    onClick={handleDeleteBatchRecords}
                                    color="error"
                                    disabled={loading || submitting}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    )}

                    <Button
                        variant="contained"
                        onClick={handleDownloadExcel}
                        size="small"
                        startIcon={loader ? <CircularProgress size={20} /> : <FileDownloadIcon />}
                        disabled={loader || loading}
                    >
                        {loader ? 'Downloading...' : 'Download Report'}
                    </Button>
                </Box>
            </Box>

            {/* Summary Statistics */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
                <Paper sx={{ p: 2, flex: 1, minWidth: 100, bgcolor: '#f5f5f5' }}>
                    <Typography variant="caption" color="textSecondary">Total Students</Typography>
                    <Typography variant="h6">{students?.length || 0}</Typography>
                </Paper>
                <Paper sx={{ p: 2, flex: 1, minWidth: 100, bgcolor: '#e8f5e9' }}>
                    <Typography variant="caption" color="textSecondary">Total Pass</Typography>
                    <Typography variant="h6" color="success.main">{resultCounts.PASS}</Typography>
                </Paper>
                <Paper sx={{ p: 2, flex: 1, minWidth: 100, bgcolor: '#ffebee' }}>
                    <Typography variant="caption" color="textSecondary">Total Fail</Typography>
                    <Typography variant="h6" color="error.main">{resultCounts.FAIL}</Typography>
                </Paper>
                <Paper sx={{ p: 2, flex: 1, minWidth: 100, bgcolor: '#fff3e0' }}>
                    <Typography variant="caption" color="textSecondary">Not Attempted</Typography>
                    <Typography variant="h6" color="textSecondary">{resultCounts.NOT_ATTEMPTED}</Typography>
                </Paper>
                <Paper sx={{ p: 2, flex: 1, minWidth: 100, bgcolor: '#e3f2fd' }}>
                    <Typography variant="caption" color="textSecondary">Total Attempted</Typography>
                    <Typography variant="h6">{resultCounts.TOTAL_ATTEMPTED}</Typography>
                </Paper>
                <Paper sx={{ p: 2, flex: 1, minWidth: 100, bgcolor: '#fce4ec' }}>
                    <Typography variant="caption" color="textSecondary">Pass Rate</Typography>
                    <Typography variant="h6">
                        {resultCounts.TOTAL_ATTEMPTED > 0 
                            ? `${Math.round((resultCounts.PASS / resultCounts.TOTAL_ATTEMPTED) * 100)}%` 
                            : '0%'}
                    </Typography>
                </Paper>
            </Box>

            {loading && <LinearProgress />}

            <Box display="flex" justifyContent="space-between" sx={{ mb: 2 }}>
                <TextField
                    label="Search Students"
                    variant="outlined"
                    value={searchTerm}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    sx={{ width: '400px' }}
                    disabled={loading}
                />
                <Typography variant="caption" color="textSecondary" sx={{ alignSelf: 'center' }}>
                    <strong>Note:</strong> This is a one-time activity. Each student's simulator attempt is recorded once.
                    <br />
                    <strong>Click "Download Report"</strong> to export all simulator records for this batch.
                    {!canDeleteData && (
                        <>
                            <br />
                            <strong style={{ color: '#f44336' }}>⚠️ Delete operations are restricted to Admin and Project Manager only.</strong>
                        </>
                    )}
                </Typography>
            </Box>
            
            <TableContainer component={Paper} sx={{ maxHeight: '70vh', overflow: 'auto' }}>
                <Table stickyHeader>
                    <TableHead>
                        <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                            <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Student ID</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Scenarios</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {studentsToDisplay?.length > 0 ? (
                            studentsToDisplay?.map((student, index) => {
                                const records = getCurrentRecords(student.id);
                                const isExpanded = expandedStudents[student.id] || false;
                                const hasAttempted = records.some(r => r.result !== 'NOT_ATTEMPTED');
                                const passCount = records.filter(r => r.result === 'PASS').length;
                                const failCount = records.filter(r => r.result === 'FAIL').length;
                                
                                return (
                                    <React.Fragment key={student.id}>
                                        <TableRow 
                                            sx={{ 
                                                bgcolor: 'transparent',
                                                '&:hover': { bgcolor: 'action.hover' }
                                            }}
                                        >
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>{student.id}</TableCell>
                                            <TableCell>{`${student.firstName} ${student.lastName}`}</TableCell>
                                            <TableCell>
                                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                                    {records.map((record, idx) => (
                                                        <Chip
                                                            key={idx}
                                                            label={`${SCENARIO_OPTIONS.find(s => s.value === record.scenario)?.label || record.scenario}: ${getResultLabel(record.result)}`}
                                                            color={getResultColor(record.result)}
                                                            size="small"
                                                            variant={record.result === 'NOT_ATTEMPTED' ? 'outlined' : 'filled'}
                                                        />
                                                    ))}
                                                </Box>
                                            </TableCell>
                                            <TableCell>
                                                {hasAttempted ? (
                                                    <Chip 
                                                        label="Attempted" 
                                                        color="primary" 
                                                        size="small"
                                                        icon={passCount > failCount ? <CheckCircleIcon /> : <CancelIconRed />}
                                                    />
                                                ) : (
                                                    <Chip 
                                                        label="Not Attempted" 
                                                        color="default" 
                                                        size="small"
                                                        variant="outlined"
                                                    />
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    <Button
                                                        size="small"
                                                        onClick={() => toggleStudentExpand(student.id)}
                                                        startIcon={<ExpandMoreIcon sx={{ transform: isExpanded ? 'rotate(180deg)' : 'none' }} />}
                                                    >
                                                        {isExpanded ? 'Hide' : 'View'}
                                                    </Button>
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                        {isExpanded && (
                                            <TableRow>
                                                <TableCell colSpan={6} sx={{ bgcolor: '#fafafa' }}>
                                                    <Box sx={{ p: 2 }}>
                                                        <Typography variant="subtitle2" sx={{ mb: 2 }}>
                                                            Simulator Scenarios for {student.firstName} {student.lastName}
                                                            <Chip 
                                                                size="small" 
                                                                label={hasAttempted ? "Attempted" : "Not Attempted"}
                                                                color={hasAttempted ? "primary" : "default"}
                                                                sx={{ ml: 2 }}
                                                            />
                                                            {!canDeleteData && (
                                                                <Chip 
                                                                    size="small" 
                                                                    label="Read Only - Delete Restricted" 
                                                                    color="warning" 
                                                                    variant="outlined"
                                                                    sx={{ ml: 1 }}
                                                                />
                                                            )}
                                                        </Typography>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>#</TableCell>
                                                                    <TableCell>Scenario</TableCell>
                                                                    <TableCell>Result</TableCell>
                                                                    <TableCell>Duration (min)</TableCell>
                                                                    <TableCell>Status</TableCell>
                                                                    <TableCell>Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {records.map((record, idx) => (
                                                                    <TableRow key={idx}>
                                                                        <TableCell>{idx + 1}</TableCell>
                                                                        <TableCell>
                                                                            {isEditing ? (
                                                                                <FormControl size="small" sx={{ minWidth: 150 }}>
                                                                                    <Select
                                                                                        value={record.scenario}
                                                                                        onChange={(e) => handleRecordChange(student.id, idx, 'scenario', e.target.value)}
                                                                                        disabled={submitting || !canEditData}
                                                                                    >
                                                                                        {SCENARIO_OPTIONS.map((option) => (
                                                                                            <MenuItem key={option.value} value={option.value}>
                                                                                                {option.label}
                                                                                            </MenuItem>
                                                                                        ))}
                                                                                    </Select>
                                                                                </FormControl>
                                                                            ) : (
                                                                                <Typography variant="body2">
                                                                                    {SCENARIO_OPTIONS.find(s => s.value === record.scenario)?.label || record.scenario}
                                                                                </Typography>
                                                                            )}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {isEditing ? (
                                                                                <FormControl size="small" sx={{ minWidth: 120 }}>
                                                                                    <Select
                                                                                        value={record.result}
                                                                                        onChange={(e) => handleRecordChange(student.id, idx, 'result', e.target.value)}
                                                                                        disabled={submitting || !canEditData}
                                                                                    >
                                                                                        <MenuItem value="NOT_ATTEMPTED">Not Attempted</MenuItem>
                                                                                        <MenuItem value="PASS">Pass</MenuItem>
                                                                                        <MenuItem value="FAIL">Fail</MenuItem>
                                                                                    </Select>
                                                                                </FormControl>
                                                                            ) : (
                                                                                <Chip
                                                                                    label={getResultLabel(record.result)}
                                                                                    color={getResultColor(record.result)}
                                                                                    size="small"
                                                                                    icon={record.result === 'PASS' ? <CheckCircleIcon /> : 
                                                                                          record.result === 'FAIL' ? <CancelIconRed /> : null}
                                                                                    variant={record.result === 'NOT_ATTEMPTED' ? 'outlined' : 'filled'}
                                                                                />
                                                                            )}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {isEditing ? (
                                                                                <TextField
                                                                                    type="number"
                                                                                    value={record.duration}
                                                                                    onChange={(e) => handleRecordChange(student.id, idx, 'duration', parseInt(e.target.value) || 0)}
                                                                                    size="small"
                                                                                    sx={{ width: 80 }}
                                                                                    InputProps={{ inputProps: { min: 0 } }}
                                                                                    disabled={submitting || !canEditData}
                                                                                />
                                                                            ) : (
                                                                                <Typography variant="body2">{record.duration} min</Typography>
                                                                            )}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {record.isNew ? (
                                                                                <Chip label="New" size="small" color="info" />
                                                                            ) : (
                                                                                <Chip label="Saved" size="small" color="success" variant="outlined" />
                                                                            )}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {isEditing && (
                                                                                <>
                                                                                    {record.id ? (
                                                                                        <Tooltip title={canDeleteData ? "Delete this scenario record" : "Only Admin and Project Manager can delete records"}>
                                                                                            <span>
                                                                                                <IconButton
                                                                                                    size="small"
                                                                                                    color="error"
                                                                                                    onClick={() => handleDeleteScenario(student.id, record.id, idx)}
                                                                                                    disabled={submitting || !canEditData || !canDeleteData}
                                                                                                >
                                                                                                    <DeleteIcon />
                                                                                                </IconButton>
                                                                                            </span>
                                                                                        </Tooltip>
                                                                                    ) : (
                                                                                        <Tooltip title={records.length <= 1 ? "Cannot remove last scenario" : "Remove this scenario"}>
                                                                                            <span>
                                                                                                <IconButton
                                                                                                    size="small"
                                                                                                    color="error"
                                                                                                    onClick={() => handleRemoveScenario(student.id, idx)}
                                                                                                    disabled={submitting || !canEditData || records.length <= 1}
                                                                                                >
                                                                                                    <DeleteIcon />
                                                                                                </IconButton>
                                                                                            </span>
                                                                                        </Tooltip>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                                {isEditing && (
                                                                    <TableRow>
                                                                        <TableCell colSpan={6}>
                                                                            <Button
                                                                                size="small"
                                                                                startIcon={<AddIcon />}
                                                                                onClick={() => handleAddScenario(student.id)}
                                                                                disabled={submitting || !canEditData}
                                                                            >
                                                                                Add Scenario
                                                                            </Button>
                                                                            {canDeleteData && (
                                                                                <Button
                                                                                    size="small"
                                                                                    color="error"
                                                                                    startIcon={<DeleteIcon />}
                                                                                    onClick={() => handleDeleteStudentRecords(student.id)}
                                                                                    disabled={submitting || !canEditData}
                                                                                    sx={{ ml: 1 }}
                                                                                >
                                                                                    Delete All Student Records
                                                                                </Button>
                                                                            )}
                                                                            {!canDeleteData && isEditing && (
                                                                                <Chip 
                                                                                    label="Delete Restricted to Admin & PM" 
                                                                                    size="small" 
                                                                                    color="warning" 
                                                                                    variant="outlined"
                                                                                    sx={{ ml: 1 }}
                                                                                />
                                                                            )}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </React.Fragment>
                                );
                            })
                        ) : (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    {filteredStudents?.length === 0 ? 'No matching students found' : 'No students available'}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                <Box>
                    {isEditing && (
                        <Typography variant="body2" component="div" color="warning.main">
                            <strong>Note:</strong> You are in edit mode. You can add/remove scenarios for each student.
                            <br />
                            {canDeleteData ? (
                                <>
                                    <strong>Delete Scenario:</strong> Click the delete icon next to a scenario to remove it.
                                    <br />
                                    <strong>Delete Student:</strong> Click "Delete All Student Records" to remove all scenarios for a student.
                                    <br />
                                    <strong>Batch Delete:</strong> Click the delete icon in the header to remove all records for this batch.
                                </>
                            ) : (
                                <>
                                    <strong style={{ color: '#f44336' }}>⚠️ Delete operations are restricted to Admin and Project Manager only.</strong>
                                    <br />
                                    <strong>Remove Scenario:</strong> You can remove unsaved (new) scenarios.
                                    <br />
                                    <strong>Delete Records:</strong> Contact Admin or Project Manager to delete saved records.
                                </>
                            )}
                        </Typography>
                    )}
                    <Typography variant="caption" color="textSecondary">
                        <strong>Tip:</strong> Click "View" to see all scenarios for a student. Only PASS/FAIL records will be saved.
                        <br />
                        <strong>One-Time Activity:</strong> Each student's simulator attempt is recorded once and can be updated.
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    {isEditing && (
                        <Button
                            variant="outlined"
                            onClick={handleEditToggle}
                            disabled={loading || submitting}
                            startIcon={<CancelIcon />}
                        >
                            Cancel Edit
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={loading || submitting || !canEditData}
                        size="large"
                        startIcon={isEditing ? <SaveIcon /> : null}
                        color={isEditing ? "warning" : "primary"}
                    >
                        {submitting ? 'Saving...' : isEditing ? 'Update' : 'Save'}
                    </Button>
                </Box>
            </Box>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Paper>
    );
};

export default Simulator;